import { useQuery } from '@tanstack/react-query'

import { useAppSelector } from 'common/hooks/redux'

import { getCategoryDetails, Region } from '../api'
import { contentKeys } from '../queryKeys'

const useGetCategoryDetailsQuery = ({
  catalogId,
  categoryId,
  region,
}: {
  catalogId: string | undefined
  categoryId: string | undefined
  region: Region | undefined
}) => {
  const accountId = useAppSelector((state) => state.authStates.accountId)

  const getCategoryDetailsQuery = useQuery({
    queryKey: contentKeys.categoryDetails({
      accountId,
      region,
      catalogId,
      categoryId,
    }),

    queryFn: () =>
      getCategoryDetails({
        accountId,
        region,
        catalogId,
        categoryId,
      }),
    enabled: !!accountId && !!catalogId && !!categoryId && !!region,
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    meta: {
      errorMessage: 'The category details could not be loaded',
    },
  })

  return getCategoryDetailsQuery
}

export default useGetCategoryDetailsQuery
